import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { logoutUser } from '../../firebase';

const UserMenu = () => {
  const { currentUser, resetAuthState } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [imageError, setImageError] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // For debugging
  useEffect(() => {
    if (currentUser) {
      console.log("Current user photo URL:", currentUser.photoURL);
    }
  }, [currentUser]);

  // Reset image error if user changes
  useEffect(() => {
    setImageError(false);
  }, [currentUser]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle logout
  const handleLogout = async () => {
    try {
      await logoutUser();
      resetAuthState();
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  // Handle image load error
  const handleImageError = () => {
    console.error("Failed to load profile image");
    setImageError(true);
  };

  if (!currentUser) return null;

  return (
    <div className="relative" ref={menuRef}>
      {/* User Avatar/Icon Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-10 h-10 rounded-full flex items-center justify-center border border-blue-200 overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 hover:shadow-sm"
      >
        {currentUser.photoURL && !imageError ? (
          <img 
            src={currentUser.photoURL} 
            alt={currentUser.displayName || 'User'} 
            className="w-full h-full object-cover"
            onError={handleImageError}
          />
        ) : (
          <User className="h-5 w-5 text-blue-600" />
        )}
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 z-20">
          {/* User Info */}
          <div className="px-4 py-2 border-b border-gray-100">
            <p className="font-medium text-sm text-gray-700 truncate">
              {currentUser.displayName || 'User'}
            </p>
            <p className="text-xs text-gray-500 truncate mt-1">
              {currentUser.email}
            </p>
          </div>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center"
          >
            <LogOut className="h-4 w-4 mr-2" />
            <span>退出登录</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;